module.exports = __webpack_public_path__ + "static/media/happy-progress-bar-icon.975ba6dd.svg";